export default __webpack_public_path__ + "static/img-7-87dc59b56d2c95866b91a501182bc70d.png";